import { IconButton, styled } from "@/theme/index";

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: "black",
  padding: theme.spacing(0.875),
  borderRadius: 100,
  border: "1px solid #E6E7E9",
  backgroundColor: "background.default",
}));
